import { gsap } from 'gsap';
import { lg } from '../common';
import { disableScroll, enableScroll } from '../lib/scroll';
import { onSamePageHashLinkClick } from '../lib/onSamePageHashLinkClick';

function initMainMenu(topbar) {
  const hamburger = topbar.querySelector('.topbar__hamburger');
  const topbarMenu = topbar.querySelector('.topbar__menu-body');
  hamburger.setAttribute('aria-expanded', 'false');

  const open = () => {
    topbar.classList.add('topbar--is-menu-open');
    hamburger.setAttribute('aria-expanded', 'true');
    setTopbarMenuScrollable(true);
    disableScroll();
  };
  const close = () => {
    topbar.classList.remove('topbar--is-menu-open');
    hamburger.setAttribute('aria-expanded', 'false');
    setTopbarMenuScrollable(false);
    enableScroll();
  };
  const toggle = () =>
    topbar.classList.contains('topbar--is-menu-open') ? close() : open();

  hamburger.addEventListener('click', toggle);

  gsap.matchMedia().add(`(min-width: ${lg}px)`, () => {
    close();
  });

  const menuTitles = topbar.querySelectorAll('button.topbar__menu-link');
  menuTitles.forEach((title) => {
    title.setAttribute('aria-expanded', 'false');
    title.addEventListener('click', (e) => {
      if (window.innerWidth < lg) {
        e.preventDefault();
        const isExpanded = title.getAttribute('aria-expanded') === 'true';
        title.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
        setTopbarMenuScrollable(true);
      }
    });
  });

  onSamePageHashLinkClick(topbar, () => {
    if (topbar.classList.contains('topbar--is-menu-open')) {
      close();
    }
  });

  function setTopbarMenuScrollable(/** @type {boolean} */ enableScroll) {
    if (enableScroll && isTopbarMenuScrollable()) {
      topbarMenu && topbarMenu.setAttribute('data-lenis-prevent', 'true');
    } else {
      topbarMenu && topbarMenu.removeAttribute('data-lenis-prevent');
    }
  }

  function isTopbarMenuScrollable() {
    return topbarMenu && topbarMenu.clientHeight < topbarMenu.scrollHeight;
  }
}

export function initTopbar() {
  const topbar = document.querySelector('.topbar');
  if (!topbar) return;

  gsap.to(topbar, { opacity: 1, duration: 0.3, ease: 'power4.in' });

  initMainMenu(topbar);
}
